import { registerPlugin } from '@capacitor/core';
const ActionSheet = registerPlugin('ActionSheet', {
    web: () => import('./web').then(m => new m.ActionSheetWeb()),
});
export * from './definitions';
export { ActionSheet };
//# sourceMappingURL=index.js.map